<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'Discussion'" [title]="'Messages'" [allExpandState]="allExpandState">
  </app-report-detail-section>
  <div #section id="Discussion" class="panel-collapse collapse">
    <div class="panel-body">
      @if ((adminDiscussion$ | async).error) {
        <p class="errorText">{{ (adminDiscussion$ | async).error }}</p>
      }
      <app-aa-spinner [loading]="(adminDiscussion$ | async).isLoading"></app-aa-spinner>
      @if (!(adminDiscussion$ | async).isLoading && !(adminDiscussion$ | async).error) {
        <div>
          @for (discussion of (adminDiscussion$ | async).detail | SortByTimeStampPipe : 'date'; track discussion) {
            <div
              class="requestResponse">
              <label class="description-timestamp">
                {{discussion.Submitter.lastName}}, {{discussion.Submitter.firstName}}
                on {{discussion.date | date:'MM/dd/yyyy'}} at {{discussion.date |
                date:'shortTime'}}
              </label>
              @if (discussion.Request) {
                <label class="description-timestamp italic">
                  Requested From:
                  @for (responder of discussion.responders; track responder; let last = $last) {
                    {{ responder.firstName }} {{responder.lastName}}
                    @if (!last) {
                      ,
                    }
                  }
                </label>
              }
              <label class="description-text">
                @if (discussion.request) {
                  <b class="description-timestamp">Request:
                  </b>
                }
                @if (!discussion.request) {
                  <b class="description-timestamp">Response:
                  </b>
                }
                {{discussion.comment}}
              </label>
            </div>
          }
          @if (!(adminDiscussion$ | async).detail.length > 0) {
            <label> No messages to show</label>
          }
          @if (featureAccessForCoreRecipient && (!displayRespondToRequestForm || (!displayRequestResponseForm && !displayRespondToRequestForm))) {
            <app-request-response-inline
              (requestResponseFormDisplaying)="updateDisplayRequestResponseForm($event)">
            </app-request-response-inline>
          }
          @if (featureAccessForFwdRecipient && (!displayRequestResponseForm || (!displayRequestResponseForm && !displayRespondToRequestForm))) {
            <app-respond-to-request-inline
              (respondToRequestFormDisplaying)="updateDisplayRespondToRequestForm($event)">
            </app-respond-to-request-inline>
          }
        </div>
      }
    </div>
  </div>
</div>
